import { PropsWithChildren } from "react";
import FixaChevronUpIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronUpIconPath";
import FixaChevronDownIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronDownIconPath";
import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import { FixaListBox } from "../../../wrappers/FixaListBox/FixaListBox";
import FilterPillCss from "./FilterPill.module.css";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { TrackingProps } from "../../types/component";
import { Filter } from "../../types/filter";

interface GroupTrackingProps extends TrackingProps {
  name: "select_pill" | "multiselect_pill" | "group_pill";
}
interface PillGroupProps {
  filter: Filter;
  listBoxIsOpen: boolean;
  setListBoxIsOpen: (isOpen: boolean) => void;
  selected?: boolean;
  tracking: GroupTrackingProps;
}

export const FilterPill = ({
  filter,
  listBoxIsOpen,
  setListBoxIsOpen,
  children,
  selected = false,
  tracking,
}: PropsWithChildren<PillGroupProps>) => {
  const { id, title } = filter;
  return (
    <div className={FilterPillCss["dropdown-pill"]}>
      <FixaPill
        id={`fixapill-${id}`}
        data-testid={`fixapill-${id}`}
        trailingIcon={
          listBoxIsOpen ? FixaChevronUpIconPath : FixaChevronDownIconPath
        }
        selected={selected}
        label={title}
        onClick={() => {
          if (!listBoxIsOpen) {
            trackerHelper.filter.trackFilterRowClicked(
              tracking.feature,
              tracking.mode,
              filter.id
            );
          }
          setListBoxIsOpen(!listBoxIsOpen);
        }}
        size="small"
      />

      {listBoxIsOpen && (
        <div
          data-testid={`fixapill-backdrop-${id}`}
          className={FilterPillCss["dropdown-backdrop"]}
          onClick={() => {
            setListBoxIsOpen(!listBoxIsOpen);
          }}
        />
      )}

      <FixaListBox
        className={FilterPillCss["dropdown-list"] ?? ""}
        multiple
        open={listBoxIsOpen}
        position="left"
      >
        {children}
      </FixaListBox>
    </div>
  );
};
